/**
 * Simulação de frete na PDP sem depender de um endpoint que a Shopify não tem
 * (o Next chama /api/shipping/simulate; aqui usamos o mesmo mecanismo do
 * carrinho, cart/async_shipping_rates.json, que só funciona com o item já no
 * carrinho). Fluxo: guarda a quantidade atual da variante no carrinho, soma
 * 1 temporariamente, consulta o frete pelo CEP e devolve a quantidade
 * original ao final (nunca zera uma quantidade que já existia de verdade).
 */
(function () {
	'use strict'

	var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'

	function formatMoney(amount) {
		return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(amount))
	}

	/**
	 * Preço de uma opção de frete. Promoção de frete grátis chega da Frenet com
	 * price "0.00" (e compare_price nulo, então não dá para riscar o valor
	 * cheio): "R$ 0,00" não diz ao cliente que ele ganhou o frete.
	 */
	function formatShippingPrice(amount) {
		return Number(amount) === 0 ? '<span class="shipping-free">Grátis</span>' : formatMoney(amount)
	}

	function brazilianProvince(postalCode) {
		var cep = Number(postalCode.replace(/\D/g, ''))
		var ranges = [
			[1000000, 19999999, 'SP'], [20000000, 28999999, 'RJ'], [29000000, 29999999, 'ES'],
			[30000000, 39999999, 'MG'], [40000000, 48999999, 'BA'], [49000000, 49999999, 'SE'],
			[50000000, 56999999, 'PE'], [57000000, 57999999, 'AL'], [58000000, 58999999, 'PB'],
			[59000000, 59999999, 'RN'], [60000000, 63999999, 'CE'], [64000000, 64999999, 'PI'],
			[65000000, 65999999, 'MA'], [66000000, 68899999, 'PA'], [68900000, 68999999, 'AP'],
			[69000000, 69299999, 'AM'], [69300000, 69399999, 'RR'], [69400000, 69899999, 'AM'],
			[69900000, 69999999, 'AC'], [70000000, 72799999, 'DF'], [72800000, 72999999, 'GO'],
			[73000000, 73699999, 'DF'], [73700000, 76799999, 'GO'], [76800000, 76999999, 'RO'],
			[77000000, 77999999, 'TO'], [78000000, 78899999, 'MT'], [79000000, 79999999, 'MS'],
			[80000000, 87999999, 'PR'], [88000000, 89999999, 'SC'], [90000000, 99999999, 'RS']
		]
		var range = ranges.find(function (entry) { return cep >= entry[0] && cep <= entry[1] })
		return range ? range[2] : ''
	}

	function shippingAddressQuery(postalCode, province) {
		return '?shipping_address%5Bzip%5D=' + encodeURIComponent(postalCode) +
			'&shipping_address%5Bcountry%5D=Brazil' +
			'&shipping_address%5Bprovince%5D=' + encodeURIComponent(province)
	}

	function parseResponse(response) {
		return response.json().then(function (data) {
			if (!response.ok) throw new Error(data.description || data.message || 'shipping-error')
			return data
		})
	}

	function pollShippingRates(postalCode, province, attempt) {
		return fetch(root + 'cart/async_shipping_rates.json' + shippingAddressQuery(postalCode, province), {
			headers: { Accept: 'application/json' }
		}).then(function (response) {
			if (response.status === 202 && attempt < 12) {
				return new Promise(function (resolve) {
					window.setTimeout(function () { resolve(pollShippingRates(postalCode, province, attempt + 1)) }, 650)
				})
			}
			return parseResponse(response)
		})
	}

	function currentLineQuantity(variantId) {
		return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
			.then(parseResponse)
			.then(function (cart) {
				var line = cart.items.find(function (item) { return String(item.variant_id) === String(variantId) })
				return line ? line.quantity : 0
			})
	}

	function setLineQuantity(variantId, quantity) {
		return fetch(root + 'cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ id: variantId, quantity: quantity })
		}).then(parseResponse)
	}

	function addVariant(variantId) {
		return fetch(root + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
		}).then(parseResponse)
	}

	/**
	 * @param {string} variantId
	 * @param {string} postalCode
	 * @returns {Promise<{rates: Array<{name: string, price: string}>}>}
	 */
	function estimateShipping(variantId, postalCode) {
		var province = brazilianProvince(postalCode)
		if (postalCode.replace(/\D/g, '').length !== 8 || !province) {
			return Promise.reject(new Error('invalid-postal'))
		}

		var originalQuantity = 0
		return currentLineQuantity(variantId)
			.then(function (quantity) {
				originalQuantity = quantity
				return addVariant(variantId)
			})
			.then(function () {
				return fetch(root + 'cart/prepare_shipping_rates.json' + shippingAddressQuery(postalCode, province), {
					method: 'POST',
					headers: { Accept: 'application/json' }
				})
			})
			.then(function (response) {
				if (!response.ok && response.status !== 202) return parseResponse(response)
				return pollShippingRates(postalCode, province, 0)
			})
			.then(function (data) {
				return setLineQuantity(variantId, originalQuantity).then(function () { return data })
			})
			.catch(function (error) {
				return setLineQuantity(variantId, originalQuantity).then(function () { throw error })
			})
	}

	window.SterilairShippingEstimate = {
		estimateShipping: estimateShipping,
		formatMoney: formatMoney,
		formatShippingPrice: formatShippingPrice
	}
})()
